import { api } from '../config';
import { getToken } from '../actions/localStorage';

export const ORDERS_CHANGED_EVENT = 'dashboard-orders-changed';

let source = null;
let connectionKey = null;
let reconnectTimer = null;

function normalizeLoja(loja) {
	if (!loja) return null;
	if (typeof loja === 'object' && loja._id != null) return String(loja._id);
	return String(loja);
}

function dispatchOrdersChanged(event) {
	try {
		const detail = JSON.parse(event.data);
		if (!detail.action && (detail.simpleId || detail.pedidoId)) {
			detail.action = 'created';
		}
		window.dispatchEvent(new CustomEvent(ORDERS_CHANGED_EVENT, { detail }));
	} catch (_) { /* ignore malformed payload */ }
}

function bindSource(es, lojaId) {
	es.addEventListener('orders-changed', dispatchOrdersChanged);
	es.addEventListener('novo-pedido', dispatchOrdersChanged);
	es.onerror = () => {
		if (es.readyState === EventSource.CLOSED && connectionKey) {
			scheduleReconnect(lojaId);
		}
	};
}

function scheduleReconnect(lojaId) {
	if (reconnectTimer) return;
	reconnectTimer = window.setTimeout(() => {
		reconnectTimer = null;
		disconnectOrderEvents();
		connectOrderEvents(lojaId);
	}, 3000);
}

export function connectOrderEvents(loja) {
	const lojaId = normalizeLoja(loja);
	const token = getToken();
	if (!lojaId || !token) {
		disconnectOrderEvents();
		return;
	}

	const key = `${lojaId}:${token}`;
	if (connectionKey === key && source?.readyState === EventSource.OPEN) return;

	disconnectOrderEvents();
	connectionKey = key;
	source = new EventSource(
		`${api}/orders/events?loja=${encodeURIComponent(lojaId)}&token=${encodeURIComponent(token)}`
	);
	bindSource(source, lojaId);
}

export function disconnectOrderEvents() {
	if (reconnectTimer) {
		window.clearTimeout(reconnectTimer);
		reconnectTimer = null;
	}
	source?.close();
	source = null;
	connectionKey = null;
}
